<template>
	<form @submit.prevent="save" ref="form">
		<b-loading :active="isLoading"></b-loading>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">
					<a
						:href="urlToOrderPdf"
						target="_blank"
						class="button is-small is-outlined is-pdf-link"
						v-if="currentOrder.id"
					>
						<i class="mdi">picture_as_pdf</i> PDF
					</a>
					<a
						:href="urlToOrderDoc"
						target="_blank"
						class="button is-small is-outlined is-doc-link"
						v-if="currentOrder.id && !isLite"
					>
						<i class="mdi">description</i> DOC
					</a>
					<span
						v-if="isMontageDateInfoVisible(currentOrder.montageDate)"
						:title="getMontageDateInfo(currentOrder.montageDate)"
						class="warning-icon"
						><i class="mdi">warning</i></span
					>
					<span v-if="!currentOrder.id">Dodawanie zamówienia</span>
					<span v-else
						>{{ isEditModeEnabled ? 'Edycja' : 'Szczegóły' }} zamówienia: #{{
							currentOrder.id
						}}</span
					>

					<button
						type="button"
						class="button is-small is-outlined to-route-button"
						@click="$parent.$emit('route-click', currentOrder.route)"
						v-if="currentOrder.route"
					>
						<i class="mdi">pageview</i>
						Trasa: {{ currentOrder.route.name }}
					</button>
				</p>
				<button
					type="button"
					class="delete"
					aria-label="close"
					@click="$parent.$emit('close')"
				></button>
			</header>
			<section class="modal-card-body">
				<!-- <div class="dates">
          <p><span>Ostatnia edycja:</span> <b>{{ currentOrder.updatedDate|date('HH:mm DD.MM.YYYY') }}</b> przez <b>Jan Kowalski</b></p>
          <p><span>Dodano:</span> <b>{{ currentOrder.createdDate|date('HH:mm DD.MM.YYYY') }}</b> przez <b>Adam Nowacki</b></p>
				</div>-->
				<div class="columns">
					<div class="column">
						<h2>Klient</h2>
						<button
							v-if="!isLite"
							class="button is-small is-outlined"
							@click.prevent="copyClientDataToClipboard"
						>
							Do schowka
						</button>
						<div class="group">
							<div class="field is-horizontal">
								<div class="field-label">* Nazwa klienta:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.clientName"
									required
									placeholder="Imię Nazwisko / Nazwa firmy"
									type="text"
									@input="currentOrder.clientName = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">* Telefon:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.phone"
									required
									placeholder="600-123-123"
									type="text"
									@input="currentOrder.phone = $event"
								/>
								<!-- <div class="field-body">
                  <span><i class="mdi">phone</i>{{ currentOrder.phone }}</span>
                  <span class="scnd-phone" v-show="currentOrder.scndPhone"><i class="mdi">phone</i>{{ currentOrder.scndPhone }}</span>
								</div>-->
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Drugi telefon:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.scndPhone"
									placeholder="600-123-123"
									type="text"
									@input="currentOrder.scndPhone = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Email:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.email"
									placeholder="jan.kowalski@email.com"
									type="email"
									@input="currentOrder.email = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Uwagi do kontaktu:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.contactNotes"
									placeholder="Dzwonić po 18:00."
									type="textarea"
									@input="currentOrder.contactNotes = $event"
								/>
							</div>
							<hr />
							<div class="field is-horizontal">
								<div class="field-label">* Kraj:</div>
								<b-field class="field-body" grouped>
									<b-select
										placeholder="Wybierz kraj"
										v-model="currentOrder.country"
										expanded
										required
										v-if="isEditModeEnabled"
									>
										<option value="PL">Polska</option>
										<option value="CZ">Czechy</option>
										<option value="SK">Słowacja</option>
										<option value="RO">Rumunia</option>
										<option value="HU">Węgry</option>
										<option value="DE">Niemcy</option>
										<option value="AT">Austria</option>
										<option value="HR">Chorwacja</option>
									</b-select>
									<span
										v-else
										v-html="
											this.$options.filters.formatCountry(currentOrder.country) || 'nie wybrano'
										"
									></span>
								</b-field>
							</div>
							<div class="field is-horizontal" v-if="isStateFieldEnabled">
								<div class="field-label">Województwo:</div>
								<b-field class="field-body" grouped v-if="currentOrder.country === 'PL'">
									<b-select
										placeholder="Wybierz województwo"
										v-model="currentOrder.state"
										expanded
										v-if="isEditModeEnabled"
									>
										<option value="dolnośląskie">dolnośląskie</option>
										<option value="kujawsko-pomorskie">kujawsko-pomorskie</option>
										<option value="lubelskie">lubelskie</option>
										<option value="lubuskie">lubuskie</option>
										<option value="łódzkie">łódzkie</option>
										<option value="małopolskie">małopolskie</option>
										<option value="mazowieckie">mazowieckie</option>
										<option value="opolskie">opolskie</option>
										<option value="podkarpackie">podkarpackie</option>
										<option value="podlaskie">podlaskie</option>
										<option value="pomorskie">pomorskie</option>
										<option value="śląskie">śląskie</option>
										<option value="świętokrzyskie">świętokrzyskie</option>
										<option value="warmińsko-mazurskie">warmińsko-mazurskie</option>
										<option value="wielkopolskie">wielkopolskie</option>
										<option value="zachodniopomorskie">zachodniopomorskie</option>
									</b-select>
									<span
										v-else
										v-html="
											this.$options.filters.formatCountry(currentOrder.state) || 'nie wybrano'
										"
									></span>
								</b-field>
								<editable
									v-else
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.state"
									placeholder="Województwo"
									type="text"
									@input="currentOrder.state = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Miasto:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.city"
									placeholder="Kraków"
									type="text"
									@input="currentOrder.city = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Ulica:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.street"
									placeholder="Szeroka 123"
									type="text"
									@input="currentOrder.street = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">* Kod pocztowy:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.postalCode"
									required
									placeholder="00-000"
									type="text"
									@input="currentOrder.postalCode = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">* Poczta:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.post"
									required
									placeholder="Poczta"
									type="text"
									@input="currentOrder.post = $event"
								/>
							</div>
							<div class="field is-horizontal" v-if="currentOrder.id">
								<div class="field-label">Lokalizacja:</div>
								<div class="field field-body">
									<button
										type="button"
										class="button is-info is-outlined"
										:disabled="!canEdit"
										@click.prevent="findLocation"
										v-if="!isLocationFormVisible && !currentOrder.lat && !currentOrder.lon"
									>
										<i class="mdi">gps_fixed</i>
										Znajdź
									</button>
									<b-dropdown
										v-if="currentOrder.lat && currentOrder.lon && !isLocationFormVisible"
										:disabled="!canEdit"
									>
										<button class="button is-info" slot="trigger" @click.prevent type="button">
											<span>
												GPS
												<small
													>({{ currentOrder.lat | toFixed(3) }},
													{{ currentOrder.lon | toFixed(3) }})</small
												>
											</span>
											<i class="mdi">arrow_drop_down</i>
										</button>
										<b-dropdown-item @click="findLocation">
											<i class="mdi">edit</i> Zmień
										</b-dropdown-item>
										<b-dropdown-item class="is-danger" @click="clearLocation">
											<i class="mdi">cancel</i> Wyczyść
										</b-dropdown-item>
									</b-dropdown>
									<div class="field is-expanded" v-if="isLocationFormVisible">
										<b-field grouped>
											<b-select
												:placeholder="
													areLocationsLoading ? 'wczytywanie lokalizacji...' : 'Wybierz lokalizację'
												"
												expanded
												:loading="areLocationsLoading"
												:disabled="areLocationsLoading"
												@input="selectedLocation = $event"
											>
												<option
													v-for="(location, index) in locations"
													:key="index"
													:value="{ lat: location.lat, lon: location.lon }"
												>
													{{ location.display_name }}
												</option>
											</b-select>
										</b-field>
										<b-field grouped class="action-buttons">
											<button
												type="button"
												class="button is-success"
												@click.prevent="updateOrderLocation(selectedLocation)"
												:disabled="!selectedLocation || areLocationsLoading"
											>
												<i class="mdi">add_location</i>
												<span>Zapisz</span>
											</button>
											<button
												type="button"
												class="button"
												@click.prevent="isLocationFormVisible = false"
												:disabled="areLocationsLoading"
											>
												<i class="mdi">cancel</i>
												<span>Anuuj</span>
											</button>
										</b-field>
									</div>
								</div>
							</div>
							<hr />
							<div class="field is-horizontal">
								<div class="field-label">Pośrednik:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.broker"
									required
									:disabled="!isAdmin"
									placeholder="Nazwa pośrednika"
									type="text"
									@input="currentOrder.broker = $event"
								/>
							</div>
							<div class="field is-horizontal" v-if="isCommissionFieldVisible">
								<div class="field-label">
									Prowizja (w {{ getCurrencyLabel(currentOrder.currency) }}):
								</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.commission"
									:currency="getCurrencyLabel(currentOrder.currency)"
									placeholder="100"
									type="currency"
									@input="currentOrder.commission = $event"
								/>
							</div>
							<div
								class="calculate-commission-wrapper"
								v-if="isCommissionFieldVisible && isCalculateCommisionEnabled"
							>
								<button
									class="button is-small is-outlined"
									@click.prevent="calculateCommission"
									v-if="isEditModeEnabled"
									:disabled="currentOrder.currency !== 'PLN'"
								>
									Oblicz prowizję
								</button>
							</div>
							<hr />
							<div class="field is-horizontal">
								<div class="field-label">Faktura:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:checked="currentOrder.isInvoice"
									@input="currentOrder.isInvoice = $event"
									type="switch"
								/>
							</div>
						</div>

						<div v-show="currentOrder.isInvoice">
							<h2>Dane na fakturze</h2>
							<button
								class="button is-small is-outlined"
								@click.prevent="copyClientAddress"
								v-if="isEditModeEnabled"
							>
								Skopiuj z danych klienta
							</button>
							<div class="group">
								<div class="field is-horizontal">
									<div class="field-label">* Nazwa firmy:</div>
									<editable
										:isEditMode="isEditModeEnabled"
										:value="currentOrder.company"
										placeholder="Firma ABC"
										type="text"
										:required="currentOrder.isInvoice"
										@input="currentOrder.company = $event"
									/>
								</div>
								<div class="field is-horizontal">
									<div class="field-label">* NIP:</div>
									<editable
										:isEditMode="isEditModeEnabled"
										:value="currentOrder.nip"
										placeholder="9999999999"
										type="text"
										:required="currentOrder.isInvoice"
										@input="currentOrder.nip = $event"
									/>
								</div>
								<div class="field is-horizontal">
									<div class="field-label">Czy firma jest płatnikiem VAT UE?:</div>
									<editable
										:isEditMode="isEditModeEnabled"
										:checked="currentOrder.isVatUE"
										@input="currentOrder.isVatUE = $event"
										type="switch"
									/>
								</div>
								<div class="field is-horizontal">
									<div class="field-label">Miasto:</div>
									<editable
										:isEditMode="isEditModeEnabled"
										:value="currentOrder.invoiceCity"
										placeholder="Miasto"
										type="text"
										@input="currentOrder.invoiceCity = $event"
									/>
								</div>
								<div class="field is-horizontal">
									<div class="field-label">Ulica:</div>
									<editable
										:isEditMode="isEditModeEnabled"
										:value="currentOrder.invoiceStreet"
										placeholder="Szeroka 123"
										type="text"
										@input="currentOrder.invoiceStreet = $event"
									/>
								</div>
								<div class="field is-horizontal">
									<div class="field-label">Kod pocztowy:</div>
									<editable
										:isEditMode="isEditModeEnabled"
										:value="currentOrder.invoicePostalCode"
										placeholder="00-000"
										type="text"
										@input="currentOrder.invoicePostalCode = $event"
									/>
								</div>
								<div class="field is-horizontal">
									<div class="field-label">Poczta:</div>
									<editable
										:isEditMode="isEditModeEnabled"
										:value="currentOrder.invoicePost"
										placeholder="Poczta"
										type="text"
										@input="currentOrder.invoicePost = $event"
									/>
								</div>
								<div class="field is-horizontal" v-if="isStateFieldEnabled">
									<div class="field-label">Województwo:</div>
									<b-field class="field-body" grouped v-if="currentOrder.country === 'PL'">
										<b-select
											placeholder="Wybierz województwo"
											v-model="currentOrder.invoiceState"
											expanded
											v-if="isEditModeEnabled"
										>
											<option value="dolnośląskie">dolnośląskie</option>
											<option value="kujawsko-pomorskie">kujawsko-pomorskie</option>
											<option value="lubelskie">lubelskie</option>
											<option value="lubuskie">lubuskie</option>
											<option value="łódzkie">łódzkie</option>
											<option value="małopolskie">małopolskie</option>
											<option value="mazowieckie">mazowieckie</option>
											<option value="opolskie">opolskie</option>
											<option value="podkarpackie">podkarpackie</option>
											<option value="podlaskie">podlaskie</option>
											<option value="pomorskie">pomorskie</option>
											<option value="śląskie">śląskie</option>
											<option value="świętokrzyskie">świętokrzyskie</option>
											<option value="warmińsko-mazurskie">warmińsko-mazurskie</option>
											<option value="wielkopolskie">wielkopolskie</option>
											<option value="zachodniopomorskie">zachodniopomorskie</option>
										</b-select>
										<span
											v-else
											v-html="
												this.$options.filters.formatCountry(currentOrder.invoiceState) ||
												'nie wybrano'
											"
										></span>
									</b-field>
									<editable
										v-else
										:isEditMode="isEditModeEnabled"
										:value="currentOrder.invoiceState"
										placeholder="Województwo"
										type="text"
										@input="currentOrder.invoiceState = $event"
									/>
								</div>
							</div>
						</div>

						<h2 v-show="!isEditModeEnabled">Historia</h2>
						<div class="group history" v-show="!isEditModeEnabled">
							<transition-group name="fade" tag="ul" class="list" mode="out-in">
								<li class="fade" v-for="log in getLogs()" :key="log.id">
									<span class="action-icon" :data-action="log.action"></span>
									<span class="editor"
										>przez {{ log.creator ? log.creator.username : '-- brak danych --' }}</span
									>
									<span class="datetime">
										<small>{{ formatDate(log.createdDate, 'HH:mm') }}</small>
										{{ formatDate(log.createdDate, 'DD/MM/YYYY') }}
									</span>
									<span class="action">- {{ formatLogAction(log) }}</span>
								</li>
							</transition-group>
							<a
								class="show-full-history"
								@click.prevent="isFullHistoryVisible = !isFullHistoryVisible"
								v-if="currentOrder.logs && currentOrder.logs.length > 5"
							>
								<span v-if="isFullHistoryVisible">
									Pokaż mniej
									<i class="mdi">expand_less</i>
								</span>
								<span v-else>
									Pokaż całą historię
									<i class="mdi">expand_more</i>
								</span>
							</a>
						</div>
					</div>
					<div class="column">
						<h2>Szczegóły zamówienia</h2>
						<button
							v-if="!isLite"
							class="button is-small is-outlined"
							@click.prevent="copyOrderDataToClipboard"
						>
							Do schowka
						</button>
						<div class="group">
							<div class="field is-horizontal">
								<div class="field-label">Rodzaj produktu:</div>
								<b-field class="field-body" grouped>
									<b-select
										placeholder="Wybierz rodzaj produktu"
										v-model="currentOrder.productType"
										expanded
										v-if="isEditModeEnabled"
									>
										<option value></option>
										<option value="kojec">kojec</option>
										<option value="garaż">garaż</option>
										<option value="brama">brama</option>
										<option value="hala">hala</option>
										<option value="domek ogrodowy">domek ogrodowy</option>
										<option value="projekt indywidualny">projekt indywidualny</option>
										<option value="drewutnia">drewutnia</option>
										<option value="garaż ocieplany">garaż ocieplany</option>
									</b-select>
									<span v-else v-html="currentOrder.productType || 'nie wybrano'"></span>
								</b-field>
							</div>
							<div class="field is-horizontal" v-if="currentOrder.productType === 'brama'">
								<div class="field-label">Rodzaj bramy:</div>
								<b-field class="field-body" grouped>
									<b-select
										placeholder="Wybierz rodzaj bramy"
										v-model="currentOrder.gateType"
										expanded
										v-if="isEditModeEnabled"
									>
										<option value></option>
										<option value="dwuskrzydłowa">dwuskrzydłowa</option>
										<option value="uchylna">uchylna</option>
									</b-select>
									<span v-else v-html="currentOrder.gateType || 'nie wybrano'"></span>
								</b-field>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Liczba sztuk:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.numberOfPieces"
									placeholder="1"
									type="number"
									@input="currentOrder.numberOfPieces = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Opis produktu:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.details"
									placeholder="Pełny opis zamówienia."
									type="textarea"
									@input="currentOrder.details = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Dodatki:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.accessories"
									placeholder="Dodatki do produktu."
									type="textarea"
									@input="currentOrder.accessories = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Link do produktu (1):</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.productLink"
									placeholder="Link do produktu online."
									type="url"
									@input="currentOrder.productLink = $event"
								/>
							</div>
							<div class="field is-horizontal" v-for="(link, index) in productsLinks" :key="index">
								<div class="field-label">Link do produktu ({{ index + 2 }}):</div>
								<div class="field field-body is-grouped" style="display: flex; flex-direction: row">
									<editable
										:isEditMode="isEditModeEnabled"
										:value="link"
										placeholder="Link do produktu online."
										type="url"
										@input="productsLinks[index] = $event"
									/>
									<button
										type="button"
										class="button"
										v-if="isEditModeEnabled"
										@click="productsLinks.splice(index, 1)"
									>
										<i class="mdi">delete</i>
									</button>
								</div>
							</div>
							<div class="field is-horizontal">
								<div class="field-label"></div>
								<button
									type="button"
									class="button is-info is-outlined"
									:disabled="!canEdit"
									v-if="isEditModeEnabled"
									@click="
										Array.isArray(productsLinks)
											? (productsLinks = [...productsLinks, ''])
											: (productsLinks = [''])
									"
								>
									<i class="mdi">add</i>
									Dodaj kolejny produkt
								</button>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">
									{{ orderPriceLabel }} (w {{ getCurrencyLabel(currentOrder.currency) }}):
								</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.price"
									:paymentVat="currentOrder.paymentVat"
									:currency="getCurrencyLabel(currentOrder.currency)"
									placeholder="2000"
									type="currency"
									@input="currentOrder.price = $event"
								/>
							</div>
							<div
								class="field is-horizontal"
								v-if="
									currentOrder.paymentMethod === 'zaliczka + gotówka' ||
									currentOrder.paymentMethod === 'zaliczka + przelew'
								"
							>
								<div class="field-label">
									Zaliczka (w {{ getCurrencyLabel(currentOrder.currency) }}):
								</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.advance"
									:paymentVat="currentOrder.paymentVat"
									:currency="getCurrencyLabel(currentOrder.currency)"
									placeholder="500"
									type="currency"
									@input="currentOrder.advance = $event"
								/>
							</div>
							<div
								class="field is-horizontal"
								v-if="
									currentOrder.paymentMethod === 'zaliczka + gotówka' ||
									currentOrder.paymentMethod === 'zaliczka + przelew'
								"
							>
								<div class="field-label">Data wpłynięcia zaliczki:</div>
								<b-field class="field-body" grouped>
									<flat-pickr
										placeholder="Wybierz datę..."
										v-model="currentOrder.advanceDate"
										v-if="isEditModeEnabled"
										:config="datePickerConfig"
										class="input"
									/>
									<span v-else>{{ currentOrder.advanceDate || 'brak daty' }}</span>
								</b-field>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">
									Pozostało do zapłaty (w {{ getCurrencyLabel(currentOrder.currency) }}):
								</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.leftToPay"
									:paymentVat="currentOrder.paymentVat"
									:currency="getCurrencyLabel(currentOrder.currency)"
									placeholder="500"
									type="currency"
									@input="currentOrder.leftToPay = $event"
								/>
							</div>
							<div class="field is-horizontal" v-if="isNettoBruttoEnabled">
								<div class="field-label">Netto/Brutto:</div>
								<b-field class="field-body" grouped>
									<b-select
										placeholder="Wybierz netto/brutto"
										v-model="currentOrder.paymentVat"
										expanded
										v-if="isEditModeEnabled"
									>
										<option value="netto 0%">netto 0%</option>
										<option value="brutto 19%">brutto 19%</option>
										<option value="brutto 23%">brutto 23%</option>
										<option value="brutto 27%">brutto 27%</option>
									</b-select>
									<span v-else v-html="currentOrder.paymentVat || 'nie wybrano'"></span>
								</b-field>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Forma płatności:</div>
								<b-field class="field-body" grouped>
									<b-select
										placeholder="Wybierz formę płatności"
										v-model="currentOrder.paymentMethod"
										expanded
										v-if="isEditModeEnabled"
									>
										<option value></option>
										<option value="gotówka">gotówka</option>
										<option value="przelew">przelew</option>
										<option value="zaliczka + gotówka">zaliczka + gotówka</option>
										<option value="zaliczka + przelew">zaliczka + przelew</option>
										<option value="przedpłata">przedpłata</option>
										<option value="płatność allegro">płatność allegro</option>
									</b-select>
									<span v-else v-html="currentOrder.paymentMethod || 'nie wybrano'"></span>
								</b-field>
							</div>
							<div class="field is-horizontal" v-if="isMultiCurrencyEnabled">
								<div class="field-label">* Waluta:</div>
								<b-field class="field-body" grouped>
									<b-select
										placeholder="Wybierz walutę"
										v-model="currentOrder.currency"
										expanded
										required
										v-if="isEditModeEnabled"
									>
										<option value="PLN">polski złoty</option>
										<option value="CZK">korona czeska</option>
										<option value="EUR">euro</option>
										<option value="RON">lej rumuński</option>
										<option value="HUF">forint</option>
									</b-select>
									<span v-else>
										<span v-if="currentOrder.currency === 'PLN'">polski złoty</span>
										<span v-if="currentOrder.currency === 'CZK'">korona czeska</span>
										<span v-if="currentOrder.currency === 'EUR'">euro</span>
										<span v-if="currentOrder.currency === 'RON'">lej rumuński</span>
										<span v-if="currentOrder.currency === 'HUF'">forint</span>
										<!-- <svg
                      class="flag"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.0"
                      viewBox="0 0 30 20"
                      v-if="currentOrder.currency === 'PLN'"
                    >
                      <rect x="0" y="0" width="100%" height="50%" fill="#fff"></rect>
                      <rect x="0" y="50%" width="100%" height="50%" fill="#d7141a"></rect>
                    </svg>
                    <svg
                      class="flag"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.0"
                      viewBox="0 0 30 20"
                      v-if="currentOrder.currency === 'CZK'"
                    >
                      <rect x="0" y="0" width="100%" height="50%" fill="#fff"></rect>
                      <rect x="0" y="50%" width="100%" height="50%" fill="#d7141a"></rect>
                      <path d="M 15,10 0,0 V 20 z" fill="#11457e"></path>
										</svg>-->
										({{ currentOrder.currency }})
									</span>
								</b-field>
							</div>
							<div class="field is-horizontal" v-show="!isEditModeEnabled">
								<div class="field-label">Status:</div>
								<div class="field-body">
									<div class="tags has-addons">
										<b-tag :type="getStatusCssClass(currentOrder.status)">{{
											currentOrder.status | formatStatus
										}}</b-tag>
										<b-tag>{{ getLastStatusDate(currentOrder.logs) }}</b-tag>
									</div>
								</div>
							</div>
							<div class="field is-horizontal" v-if="currentOrder.id">
								<div class="field-label">Trasa:</div>
								<div class="field-body">
									<div v-if="currentOrder.route">
										<b-dropdown
											:disabled="isNewRouteFormVisible || isChangeRouteFormVisible || !canEdit"
										>
											<button class="button is-info" slot="trigger" @click.prevent type="button">
												<span>{{ currentOrder.route.name }}</span>
												<i class="mdi">arrow_drop_down</i>
											</button>
											<b-dropdown-item @click="$parent.$emit('route-click', currentOrder.route)">
												<i class="mdi">pageview</i> Podgląd trasy
											</b-dropdown-item>
											<b-dropdown-item @click="showChangeRouteForm">
												<i class="mdi">edit</i> Zmień trasę
											</b-dropdown-item>
											<b-dropdown-item class="is-danger" @click="removeFromRoute">
												<i class="mdi">cancel</i> Usuń z trasy
											</b-dropdown-item>
										</b-dropdown>
									</div>
									<b-field v-if="!currentOrder.route">
										<b-dropdown
											:disabled="isNewRouteFormVisible || isChangeRouteFormVisible || !canEdit"
										>
											<button class="button is-info is-outlined" slot="trigger" @click.prevent>
												<span>Przypisz</span>
												<i class="mdi">arrow_drop_down</i>
											</button>
											<b-dropdown-item @click="showAddRouteForm">do nowej trasy</b-dropdown-item>
											<b-dropdown-item @click="showChangeRouteForm"
												>do obecnej trasy</b-dropdown-item
											>
										</b-dropdown>
									</b-field>
								</div>
							</div>
							<div class="field is-horizontal" v-if="isNewRouteFormVisible">
								<div class="field-label">Nowa trasa:</div>
								<div class="field-body">
									<div class="field is-expanded">
										<b-field grouped>
											<b-input
												v-model="newRouteName"
												placeholder="Nazwa nowej trasy"
												expanded
											></b-input>
										</b-field>
										<b-field grouped class="action-buttons">
											<button
												type="button"
												class="button is-success"
												@click.prevent="addToNewRoute"
												:disabled="!newRouteName"
											>
												<i class="mdi">add</i>
												<span>Utwórz trasę</span>
											</button>
											<button type="button" class="button" @click.prevent="hideAddRouteForm">
												<i class="mdi">cancel</i>
												<span>Zamknij</span>
											</button>
										</b-field>
									</div>
								</div>
							</div>
							<div class="field is-horizontal" v-if="isChangeRouteFormVisible">
								<div class="field-label">Przypisanie do trasy:</div>
								<div class="field-body">
									<div class="field is-expanded">
										<b-field grouped>
											<b-select
												:placeholder="
													areActiveRoutesLoading ? 'wczytywanie tras...' : 'Wybierz trasę'
												"
												expanded
												:value="
													currentOrder.route ? getRouteIndexById(currentOrder.route.id) : null
												"
												:loading="areActiveRoutesLoading"
												:disabled="areActiveRoutesLoading"
												@input="selectedRoute = activeRoutes[$event]"
											>
												<option v-for="(route, index) in activeRoutes" :value="index" :key="index">
													{{ route.name }} ({{ route.orders.length }})
												</option>
											</b-select>
										</b-field>
										<b-field grouped class="action-buttons">
											<button
												type="button"
												class="button is-success"
												@click.prevent="addToExisitingRoute"
												:disabled="!selectedRoute || areActiveRoutesLoading"
											>
												<i class="mdi">add</i>
												<span>Przypisz</span>
											</button>
											<button
												type="button"
												class="button"
												@click.prevent="hideChangeRouteForm"
												:disabled="areActiveRoutesLoading"
											>
												<i class="mdi">cancel</i>
												<span>Anuuj</span>
											</button>
										</b-field>
									</div>
								</div>
							</div>
							<div class="field is-horizontal" v-if="!isLite">
								<div class="field-label">Pilne:</div>
								<b-field class="field-body" grouped>
									<b-switch
										v-model="currentOrder.isUrgent"
										v-if="isEditModeEnabled"
										type="is-error"
										>{{ currentOrder.isUrgent ? 'tak' : 'nie' }}</b-switch
									>
									<span v-else>{{ currentOrder.isUrgent ? 'tak' : 'nie' }}</span>
								</b-field>
							</div>
							<hr />
							<div class="field is-horizontal" v-if="currentOrder.id">
								<div class="field-label">Załącznik:</div>
								<div class="field-body picture-wrapper">
									<vue-preview
										v-if="currentOrder.image && currentOrder.image.imageDimensions"
										:slides="slides"
										class="picture"
									/>
									<a
										v-if="currentOrder.image && !currentOrder.image.imageDimensions"
										:href="docFile"
										target="_blank"
									>
										<img
											:src="`${path}/img/doc-bg.png`"
											width="510"
											height="383"
											alt="Załącznik"
											class="picture"
										/>
										<p>{{ currentOrder.image.filePath }}</p>
									</a>
									<p v-if="!currentOrder.image && !isEditModeEnabled" class="picture__empty">
										Brak załącznika - przejdź do edycji, aby wgrać załącznik.
									</p>
									<b-field class="picture__buttons" v-if="isEditModeEnabled">
										<b-upload
											v-model="file"
											accept="image/*, application/pdf, .doc, .odt, .docx"
											@input="onFileInputChange"
											:loading="isUploading"
										>
											<a
												class="button is-info"
												:class="{ 'is-loading': isUploading }"
												:disabled="isUploading"
											>
												<i class="mdi">cloud_upload</i>
												<span>{{ currentOrder.image ? 'Zmień' : 'Wybierz' }}</span>
											</a>
										</b-upload>
										<span class="file-name" v-if="file">{{ filename }}</span>
										<button
											type="button"
											class="button is-danger"
											:disabled="isUploading"
											v-if="currentOrder.image && isEditModeEnabled"
											@click="deletePicture"
										>
											<i class="mdi">delete</i>
										</button>
									</b-field>
								</div>
							</div>
						</div>

						<h2>Montaż</h2>
						<div class="group montage">
							<div class="field is-horizontal">
								<div class="field-label">Uwagi do montażu:</div>
								<editable
									:isEditMode="isEditModeEnabled"
									:value="currentOrder.montageNotes"
									placeholder="Uwagi dotyczące montażu."
									type="textarea"
									@input="currentOrder.montageNotes = $event"
								/>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Data montażu:</div>
								<b-field class="field-body" grouped>
									<flat-pickr
										placeholder="Wybierz datę..."
										v-model="currentOrder.montageDate"
										v-if="isEditModeEnabled"
										:config="datePickerConfig"
										class="input"
									/>
									<span v-else>{{ currentOrder.montageDate }}</span>
								</b-field>
							</div>
							<div class="field is-horizontal">
								<div class="field-label">Godzina montażu:</div>
								<b-field class="field-body" grouped>
									<flat-pickr
										placeholder="Wybierz godzinę..."
										v-model="currentOrder.montageTime"
										v-if="isEditModeEnabled"
										:config="timePickerConfig"
										class="input"
									/>
									<span v-else>{{ currentOrder.montageTime }}</span>
								</b-field>
							</div>
							<div class="field is-horizontal" v-if="!isLite">
								<div class="field-label">Zatwierdzone:</div>
								<b-field class="field-body" grouped>
									<b-switch
										v-model="currentOrder.isApproved"
										v-if="isEditModeEnabled"
										type="is-warning"
										>{{ currentOrder.isApproved ? 'tak' : 'nie' }}</b-switch
									>
									<span v-else>{{ currentOrder.isApproved ? 'tak' : 'nie' }}</span>
								</b-field>
							</div>
							<div class="field is-horizontal" v-if="!isLite">
								<div class="field-label">FV wysłana:</div>
								<b-field class="field-body" grouped>
									<b-switch
										v-model="currentOrder.isInvoiceSent"
										v-if="isEditModeEnabled"
										type="is-info"
										>{{ currentOrder.isInvoiceSent ? 'tak' : 'nie' }}</b-switch
									>
									<span v-else>{{ currentOrder.isInvoiceSent ? 'tak' : 'nie' }}</span>
								</b-field>
							</div>
							<div class="field is-horizontal" v-if="!isLite">
								<div class="field-label">FV zapłacona:</div>
								<b-field class="field-body" grouped>
									<b-switch
										v-model="currentOrder.isInvoicePaid"
										v-if="isEditModeEnabled"
										type="is-danger"
										>{{ currentOrder.isInvoicePaid ? 'tak' : 'nie' }}</b-switch
									>
									<span v-else>{{ currentOrder.isInvoicePaid ? 'tak' : 'nie' }}</span>
								</b-field>
							</div>
						</div>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot">
				<div class="level">
					<div class="level-left">
						<button type="submit" class="button is-success button--save" v-if="isEditModeEnabled">
							<i class="mdi">save</i> Zapisz zmiany
						</button>
						<button
							class="button is-primary button--edit"
							:disabled="!canEdit"
							@click.prevent="isEditModeEnabled = true"
							v-else
						>
							<i class="mdi">edit</i> Edytuj
						</button>
						<!-- <button
              class="button is-info"
              @click.prevent="$parent.$emit('route-click', currentOrder.route)"
              v-if="currentOrder.route"
						>Trasa</button>-->
						<button class="button is-white button--cancel" @click.prevent="$parent.$emit('close')">
							Zamknij
						</button>
						<p v-if="!isAdmin && !agentsCanEditEverything && secondsLeftToEdit > 0">
							Pozostało Ci {{ Math.floor(secondsLeftToEdit / 60) }} minut
							{{ secondsLeftToEdit - Math.floor(secondsLeftToEdit / 60) * 60 }} sekund na edycję.
						</p>
					</div>
					<div class="level-right">
						<button
							class="button is-info"
							@click.prevent="accept"
							v-if="currentOrder.status === 'pending'"
						>
							Akceptuj
						</button>
						<b-dropdown position="is-top-left">
							<button class="button" slot="trigger" @click.prevent type="button">
								<span>Więcej</span>
								<i class="mdi">arrow_drop_down</i>
							</button>
							<b-dropdown-item
								v-if="currentOrder.status !== 'archived'"
								@click="archive"
								:disabled="!canEdit"
							>
								<i class="mdi">archive</i> Archiwizuj
							</b-dropdown-item>
							<b-dropdown-item
								@click="accept"
								v-if="currentOrder.status === 'pending'"
								:disabled="!canEdit"
							>
								<i class="mdi">check</i> Akceptuj
							</b-dropdown-item>
							<b-dropdown-item
								v-if="currentOrder.status !== 'complaint' && config.canMoveToComplaints"
								:disabled="!canEdit"
								@click="moveToComplaint"
							>
								<i class="mdi">refresh</i> Reklamacja
							</b-dropdown-item>
							<b-dropdown-item
								v-if="currentOrder.status !== 'trashed' && config.canMoveToTrash"
								:disabled="!canEdit"
								@click="moveToTrash"
							>
								<i class="mdi">delete_forever</i> Do kosza
							</b-dropdown-item>
							<b-dropdown-item :disabled="!canEdit" @click="showDeleteDialog">
								<i class="mdi">cancel</i> Usuń permanentnie
							</b-dropdown-item>
							<b-dropdown-item
								v-if="canDuplicateOrder"
								:disabled="!canEdit"
								@click="showDuplicateDialog"
							>
								<i class="mdi">content_copy</i> Duplikuj
							</b-dropdown-item>
							<b-dropdown-item
								class="is-danger"
								@click="$parent.$emit('route-click', currentOrder.route)"
								:disabled="!currentOrder.route"
							>
								<i class="mdi">pageview</i> Trasa
							</b-dropdown-item>
							<hr
								class="dropdown-divider"
								v-if="
									currentOrder.status === 'planned' ||
									currentOrder.status === 'archived' ||
									currentOrder.status === 'trashed' ||
									currentOrder.status === 'complaint'
								"
							/>
							<b-dropdown-item
								class="is-danger"
								:disabled="!canEdit"
								v-if="
									currentOrder.status === 'planned' ||
									currentOrder.status === 'sent' ||
									currentOrder.status === 'archived' ||
									currentOrder.status === 'trashed' ||
									currentOrder.status === 'complaint'
								"
								@click="unarchiveToPending"
							>
								<i class="mdi">archive</i> Przenieś do oczekujących
							</b-dropdown-item>
							<b-dropdown-item
								class="is-danger"
								:disabled="!canEdit"
								v-if="
									currentOrder.status === 'planned' ||
									currentOrder.status === 'sent' ||
									currentOrder.status === 'archived' ||
									currentOrder.status === 'trashed' ||
									currentOrder.status === 'complaint'
								"
								@click="unarchiveToNew"
							>
								<i class="mdi">archive</i> Przenieś do nowych
							</b-dropdown-item>
						</b-dropdown>
						<!-- 
            <button
              class="button is-danger is-small button--delete"
              @click.prevent="showDeleteDialog"
						>Usuń</button>-->
					</div>
				</div>
			</footer>
		</div>
	</form>
</template>

<script>
import bus from '@/EventBus'
import { copyTextToClipboard } from '@/helpers'
import config from '@/config'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import EditableField from '@/components/EditableField'
import UploadService from '@/services/UploadService'
import flatPickr from 'vue-flatpickr-component'
import { Polish } from 'flatpickr/dist/l10n/pl'
import 'flatpickr/dist/flatpickr.css'

export default {
	name: 'ViewOrderModal',
	components: {
		editable: EditableField,
		flatPickr
	},
	data() {
		return {
			newRouteName: '',
			selectedRoute: null,
			isLocationFormVisible: false,
			areLocationsLoading: false,
			selectedLocation: null,
			locations: [],
			isLoading: false,
			isUploading: false,
			isEditModeEnabled: this.isEditModeActive,
			activeRoutes: [], // not archived routes that orders can be assigned to
			areRoutesLoading: false,
			areActiveRoutesLoading: false,
			isChangeRouteFormVisible: false,
			isNewRouteFormVisible: false,
			isFullHistoryVisible: false,
			file: null,
			datePickerConfig: {
				dateFormat: 'd-m-Y',
				locale: Polish
			},
			timePickerConfig: {
				enableTime: true,
				noCalendar: true,
				dateFormat: 'H:i',
				time_24hr: true
			},
			secondsLeftToEdit: 0,
			timeToEditInterval: 0,
			productsLinks: []
		}
	},
	computed: {
		...mapState('orders', ['currentOrder']),
		...mapState('modals', ['isEditModeActive']),
		...mapGetters('auth', ['isAdmin', 'user']),
		clientDataToClipboard() {
			let data = this.currentOrder.clientName
			let address = '\n'

			address += this.currentOrder.street ? 'ul. ' + this.currentOrder.street : ''
			address += this.currentOrder.post ? ', ' + this.currentOrder.post : ''
			address += this.currentOrder.street || this.currentOrder.post ? ', ' : ''
			address += this.currentOrder.postalCode ? this.currentOrder.postalCode : ''
			address += this.currentOrder.city ? ' ' + this.currentOrder.city : ''
			address += '\nfaktura: '
			address += this.currentOrder.isInvoice ? '' : 'nie'
			if (this.currentOrder.isInvoice) {
				address += this.currentOrder.company ? this.currentOrder.company : ''
				address += this.currentOrder.nip ? ', NIP: ' + this.currentOrder.nip : ''
				address += this.currentOrder.invoiceStreet ? ', ul. ' + this.currentOrder.invoiceStreet : ''
				address += this.currentOrder.invoicePost ? ', ' + this.currentOrder.invoicePost : ''
				address += this.currentOrder.invoiceStreet || this.currentOrder.invoicePost ? ', ' : ''
				address += this.currentOrder.invoicePostalCode ? this.currentOrder.invoicePostalCode : ''
				address += this.currentOrder.invoiceCity ? ' ' + this.currentOrder.invoiceCity : ''
			}

			data += address
			data += '\ntel. ' + this.currentOrder.phone
			data += this.currentOrder.scndPhone ? '\ntel. ' + this.currentOrder.scndPhone : ''
			data += this.currentOrder.broker ? '\n' + this.currentOrder.broker : ''

			return data
		},
		orderDataToClipboard() {
			let currency = ''
			switch (this.currentOrder.currency) {
				case 'PLN':
					currency = 'zł'
					break
				case 'CZK':
					currency = 'Kč'
					break
				default:
					currency = this.currentOrder.currency
			}
			let text = ''
			text += this.currentOrder.details ? 'Zamówienie: ' + this.currentOrder.details + '\n' : ''
			text += this.currentOrder.productType
				? 'Rodzaj produktu: ' + this.currentOrder.productType + '\n'
				: ''
			if (this.currentOrder.productType === 'brama') {
				text += 'Rodzaj bramy: '
				text += this.currentOrder.gateType + '\n'
			}
			text += this.currentOrder.montageNotes
				? 'Uwagi do montażu: ' + this.currentOrder.montageNotes + '\n'
				: ''
			if (this.currentOrder.montageDate) {
				text += 'Data montażu: '
				if (this.currentOrder.montageTime) text += this.currentOrder.montageTime + '\n'
				text += this.currentOrder.montageDate + '\n'
			}
			if (this.currentOrder.price) {
				text += 'Cena: ' + this.currentOrder.price + ' ' + currency
				if (this.currentOrder.paymentVat) text += ' ' + this.currentOrder.paymentVat
			} else text += 'Cena: ?'

			return text.trim()
		},
		urlToOrderPdf() {
			if (!this.currentOrder) return ''
			const token = localStorage.getItem('token')
			return config.service.orderPdfURL + this.currentOrder.id + '?bearer=' + token
		},
		urlToOrderDoc() {
			if (!this.currentOrder) return ''
			const token = localStorage.getItem('token')
			return config.service.orderDocURL + this.currentOrder.id + '?bearer=' + token
		},
		docFile() {
			if (!this.currentOrder.image.filePath) return ''
			return config.service.apiRootURL + 'media/' + this.currentOrder.image.filePath
		},
		filename() {
			return this.file[0].name && this.file[0].name.length > 15
				? this.file[0].name.substr(0, 15) + '...'
				: this.file[0].name
		},
		slides() {
			// if (!this.currentOrder.image || !this.currentOrder.image.imageDimensions) return null
			if (!this.currentOrder.image) return null
			return [
				{
					src: this.currentOrder.image.contentUrl
						? config.service.apiRootURL + this.currentOrder.image.contentUrl.substr(1)
						: config.service.apiRootURL + 'media/' + this.currentOrder.image.filePath,
					msrc: this.currentOrder.image.contentUrl
						? config.service.apiRootURL + this.currentOrder.image.contentUrl.substr(1)
						: config.service.apiRootURL + 'media/' + this.currentOrder.image.filePath,
					alt: 'rysunek',
					title: 'Rysunek',
					w: this.currentOrder.image.imageDimensions[0],
					h: this.currentOrder.image.imageDimensions[1]
				}
			]
		},
		isNettoBruttoEnabled() {
			return config.company.isNettoBruttoEnabled
		},
		isMultiCurrencyEnabled() {
			return config.company.isMultiCurrencyEnabled
		},
		canNonAdminSeeRouteAsAdmin() {
			return config.company.canNonAdminSeeRouteAsAdmin
		},
		agentsCanEditEverything() {
			return config.company.agentsCanEditEverything
		},
		canDuplicateOrder() {
			return config.company.canDuplicateOrder
		},
		canEdit() {
			return this.isAdmin || config.company.agentsCanEditEverything || this.secondsLeftToEdit > 0
		},
		isCalculateCommisionEnabled() {
			return location.hostname === 'orders.blachtrans.com'
		},
		isCommissionFieldVisible() {
			return config.company.isCommissionFieldVisible
		},
		isStateFieldEnabled() {
			return config.company.isStateFieldEnabled
		},
		orderPriceLabel() {
			return config.company.orderPriceLabel
		},
		path() {
			return config.company.appSubPathname ? `/${config.company.appSubPathname}` : ''
		},
		isLite() {
			return config.company.isLite
		},
		config() {
			return config.company
		}
	},
	filters: {
		formatStatus(status) {
			return config.company.orderStatusNames[status]
		},
		formatCountry(country) {
			switch (country) {
				case 'PL':
					return 'Polska'
				case 'CZ':
					return 'Czechy'
				case 'SK':
					return 'Słowacja'
				case 'RO':
					return 'Rumunia'
				case 'HU':
					return 'Węgry'
				case 'DE':
					return 'Niemcy'
				case 'AT':
					return 'Austria'
				case 'HR':
					return 'Chorwacja'
				default:
					return country
			}
		},
		toFixed(value, precise) {
			return Number(value).toFixed(precise)
		}
	},
	methods: {
		showAddRouteForm() {
			this.isNewRouteFormVisible = true
		},
		hideAddRouteForm() {
			this.isNewRouteFormVisible = false
		},
		showChangeRouteForm() {
			this.isChangeRouteFormVisible = true
			this.areActiveRoutesLoading = true
			this.$store
				.dispatch('routes/getActiveRoutes', {
					by: 'status',
					value: ['planned', 'sent']
				})
				.then((routes) => {
					this.activeRoutes = routes
					this.areActiveRoutesLoading = false
				})
		},
		hideChangeRouteForm() {
			this.isChangeRouteFormVisible = false
		},
		showViewRouteModal(route) {
			this.isLoading = true
			this.$store.dispatch('routes/setCurrentRoute', route).then(() => {
				this.isLoading = false
				this.$store.dispatch('modals/showViewRouteModal')
			})
		},
		formatDate(value, format) {
			return moment(value).format(format)
		},
		formatLogAction(log) {
			let logActionText = ''
			switch (log.action) {
				case 'create':
					logActionText = 'dodanie zamówienia'
					break
				case 'update':
					logActionText = 'edycja'
					break
				case 'status change':
					logActionText = 'zmiana statusu na ' + this.$options.filters.formatStatus(log.details)
					break
			}
			return logActionText
		},
		getRouteIndexById(routeId) {
			let resultIndex
			this.activeRoutes.forEach((route, index) => {
				if (route.id === routeId) resultIndex = index
			})
			return resultIndex
		},
		getStatusCssClass(status) {
			switch (status) {
				case 'new':
					return 'is-success'
				case 'pending':
					return 'is-primary'
				case 'planned':
					return 'is-warning'
				case 'sent':
					return 'is-info'
				case 'archived':
				case 'complaint':
					return 'is-danger'
				case 'trashed':
					return 'is-default'
			}
		},
		getLastStatusDate(logs) {
			if (!logs) return
			const latestStatusChangeLog = logs.filter(
				(log) => log.action === 'status change' || log.action === 'create'
			)[0]
			return this.formatDate(latestStatusChangeLog.createdDate, 'HH:mm DD.MM.YYYY')
		},
		findLocation() {
			this.isLocationFormVisible = true
			this.areLocationsLoading = true
			this.$store.dispatch('orders/findLocation').then((locations) => {
				if (!locations.length) {
					this.$toast.open({
						type: 'is-danger',
						message: 'Nie znaleziono lokalizacji dla podanych danych adresowych.'
					})
					this.isLocationFormVisible = false
				} else this.locations = locations
				this.areLocationsLoading = false
			})
		},
		clearLocation() {
			this.isLoading = true
			this.$store.dispatch('orders/clearLocation').then(() => {
				this.$snackbar.open('Usunięto lokalizację GPS z zamówienia.')
				this.isLoading = false
				bus.$emit('order-updated')
			})
		},
		updateOrderLocation(location) {
			this.isLocationFormVisible = false
			this.isLoading = true
			this.$store.dispatch('orders/updateOrderLocation', location).then(() => {
				this.isLoading = false
				this.$snackbar.open('Zaktualizowano lokalizację GPS dla zamówienia.')
				bus.$emit('order-updated')
			})
			// console.log('updateOrderLocation', order, location)
		},
		save() {
			this.isLoading = true

			// stringify productsLinks array
			this.currentOrder.productsLinks = this.productsLinks.length
				? JSON.stringify(this.productsLinks)
				: null

			if (this.currentOrder.id) {
				// update
				this.$store.dispatch('orders/updateOrder', this.currentOrder).then((order) => {
					this.isLoading = false
					this.isEditModeEnabled = false
					this.$snackbar.open(`Zamówienie #${order.id} zostało edytowane.`)
					bus.$emit('order-updated')
				})
			} else {
				// create
				this.$store.dispatch('orders/createOrder', { order: this.currentOrder }).then((order) => {
					this.isLoading = false
					this.isEditModeEnabled = false
					this.$snackbar.open(`Zamówienie #${order.id} zostało dodane.`)
					bus.$emit('order-created')
				})
			}
		},
		accept() {
			this.isLoading = true
			this.$store.dispatch('orders/acceptOrder', this.currentOrder).then((order) => {
				this.isLoading = false
				this.$snackbar.open(`Zamówienie #${order.id} zostało przeniesione do nowych.`)
				bus.$emit('order-accepted')
			})
		},
		moveToTrash() {
			this.isLoading = true
			this.$store.dispatch('orders/moveToTrash', this.currentOrder).then((order) => {
				this.isLoading = false
				this.$snackbar.open(`Zamówienie #${order.id} zostało przeniesione do kosza.`)
				bus.$emit('order-trashed')
			})
		},
		moveToComplaint() {
			this.isLoading = true
			this.$store.dispatch('orders/moveToComplaint', this.currentOrder).then((order) => {
				this.isLoading = false
				this.$snackbar.open(`Zamówienie #${order.id} zostało oznaczone jako reklamacja.`)
				bus.$emit('order-complaint')
			})
		},
		archive() {
			this.isLoading = true
			this.$store.dispatch('orders/archiveOrder', this.currentOrder).then((order) => {
				this.isLoading = false
				this.$snackbar.open(`Zamówienie #${order.id} zostało zarchiwizowane.`)
				bus.$emit('order-archived')
			})
		},
		unarchiveToNew() {
			this.isLoading = true
			this.$store.dispatch('orders/unarchiveOrderToNew', this.currentOrder).then((order) => {
				this.isLoading = false
				this.$snackbar.open(
					`Zamówienie #${order.id} zostało przywrócone z archiwum do nowych zamówień.`
				)
				bus.$emit('order-unarchived')
			})
		},
		unarchiveToPending() {
			this.isLoading = true
			this.$store.dispatch('orders/unarchiveOrderToPending', this.currentOrder).then((order) => {
				this.isLoading = false
				this.$snackbar.open(
					`Zamówienie #${order.id} zostało przywrócone z archiwum do zamówień oczekujących.`
				)
				bus.$emit('order-unarchived')
			})
		},
		showDeleteDialog() {
			this.$dialog.confirm({
				title: `Usuwanie zamówienia: #${this.currentOrder.id}`,
				message: `Czy na pewno usunąć zamówienie klienta "${this.currentOrder.clientName}"?`,
				confirmText: 'Tak, usuń',
				cancelText: 'Anuluj',
				type: 'is-danger',
				hasIcon: true,
				onConfirm: () => this.deleteOrder()
			})
		},
		showDuplicateDialog() {
			this.$dialog.confirm({
				title: `Duplikowanie zamówienia: #${this.currentOrder.id}`,
				message: `Czy na pewno zduplikować zamówienie klienta "${this.currentOrder.clientName}"?`,
				confirmText: 'Tak, duplikuj',
				cancelText: 'Anuluj',
				type: 'is-info',
				hasIcon: true,
				onConfirm: () => this.duplicateOrder()
			})
		},
		duplicateOrder() {
			this.isLoading = true
			const duplicatedOrderId = this.currentOrder.id
			const orderToDuplicate = { ...this.currentOrder }
			delete orderToDuplicate.id
			delete orderToDuplicate.logs
			delete orderToDuplicate.creator
			delete orderToDuplicate.createdDate
			delete orderToDuplicate.updatedDate
			delete orderToDuplicate.route
			delete orderToDuplicate.isInvoiceSent
			delete orderToDuplicate.isInvoicePaid
			delete orderToDuplicate.montageDate
			delete orderToDuplicate.montageTime
			delete orderToDuplicate.emailSent
			orderToDuplicate.status = 'pending'
			orderToDuplicate.isApproved = false
			if (this.currentOrder.image) orderToDuplicate.image = this.currentOrder.image['@id']

			this.$store.dispatch('orders/createOrder', { order: orderToDuplicate }).then((order) => {
				this.isLoading = false
				this.$snackbar.open(
					`Zamówienie #${order.id} zostało dodane przez powielenie zamówienia #${duplicatedOrderId}.`
				)
				bus.$emit('order-duplicated')
			})
		},
		deleteOrder() {
			this.isLoading = true
			this.$store.dispatch('orders/deleteOrder', this.currentOrder).then((order) => {
				this.isLoading = false
				this.$snackbar.open(`Zamówienie #${order.id} zostało usunięte.`)
				this.$parent.$emit('close')
				bus.$emit('order-deleted')
			})
		},
		addToExisitingRoute() {
			this.isLoading = true
			this.$store
				.dispatch('orders/addToExisitingRoute', {
					order: this.currentOrder,
					route: this.selectedRoute
				})
				.then((order) => {
					this.isLoading = false
					this.isChangeRouteFormVisible = false
					this.$snackbar.open(
						`Zamówienie #${order.id} zostało przypisane do trasy "${order.route.name}".`
					)
					bus.$emit('route-attached')
				})
		},
		addToNewRoute() {
			this.isLoading = true
			this.$store
				.dispatch('orders/addToNewRoute', {
					order: this.currentOrder,
					routeName: this.newRouteName,
					creatorId: this.user.id
				})
				.then((order) => {
					this.isLoading = false
					this.isNewRouteFormVisible = false
					this.$snackbar.open(
						`Zamówienie #${order.id} zostało przypisane do nowej trasy "${order.route.name}".`
					)
					bus.$emit('route-attached')
				})
		},
		removeFromRoute() {
			const routeName = this.currentOrder.route.name
			this.isLoading = true
			this.$store.dispatch('orders/removeFromRoute', this.currentOrder).then((order) => {
				this.isLoading = false
				this.$snackbar.open(`Zamówienie #${order.id} zostało odłączone od trasy "${routeName}".`)
				bus.$emit('route-detached')
			})
		},
		getLogs() {
			if (!this.currentOrder.logs) return []
			return this.isFullHistoryVisible ? this.currentOrder.logs : this.currentOrder.logs.slice(0, 5)
		},
		copyClientDataToClipboard() {
			copyTextToClipboard(this.clientDataToClipboard)
			this.$toast.open({
				type: 'is-info',
				message: `Dane klienta zostały skopiowane do schowka.`
			})
		},
		copyOrderDataToClipboard() {
			copyTextToClipboard(this.orderDataToClipboard)
			this.$toast.open({
				type: 'is-info',
				message: `Dane zamówienia zostały skopiowane do schowka.`
			})
		},
		copyClientAddress() {
			this.currentOrder.invoiceCity = this.currentOrder.city
			this.currentOrder.invoiceStreet = this.currentOrder.street
			this.currentOrder.invoicePostalCode = this.currentOrder.postalCode
			this.currentOrder.invoiceState = this.currentOrder.state
			this.currentOrder.invoicePost = this.currentOrder.post

			this.$toast.open({
				type: 'is-info',
				message: `Dane adresowe klienta zostały skopiowane do danych na fakturze.`
			})
		},
		onFileInputChange() {
			this.isUploading = true
			this.$snackbar.open(`Rozpoczęto wysyłkę załącznika...`)

			const formData = new FormData()
			const fileToUpload = this.file[0]

			// append timestamp to filename to prevent caching but split filename and extension first
			const fileName = fileToUpload.name.split('.')[0]
			const fileExtension = fileToUpload.name.split('.').pop()
			const finalFilename = `${fileName}_${Date.now()}.${fileExtension}`

			formData.append('file', fileToUpload, finalFilename)

			UploadService.upload(formData)
				.then((response) => {
					this.$toast.open({
						type: 'is-success',
						message: 'Załącznik został wgrany na serwer, można zapisać zmiany w zamówieniu.'
					})
					this.currentOrder.image = response.data
				})
				.catch((errors) => {
					this.$toast.open({
						type: 'is-error',
						message: 'Wystąpił błąd i załącznik nie został zapisany.'
					})
					console.log('errors', errors)
				})
				.then(() => {
					this.isUploading = false
					this.file = null
				})
		},
		deletePicture() {
			this.$snackbar.open(`Usunięto załącznik.`)
			this.currentOrder.image = null
			this.file = null
		},
		getCurrencyLabel(currency) {
			switch (currency) {
				case 'PLN':
					return 'zł'
				case 'CZK':
					return 'Kč'
				default:
					return currency
			}
		},
		isMontageDateInfoVisible(montageDate) {
			const montageDateMoment = moment(montageDate, 'DD-MM-YYYY')
			const nowMoment = moment(new Date())
			const diffInDays = montageDateMoment.diff(nowMoment, 'days')

			return diffInDays < 14 && montageDateMoment.isAfter(nowMoment)
		},
		getMontageDateInfo(montageDate) {
			const montageDateMoment = moment(montageDate, 'DD-MM-YYYY')
			const nowMoment = moment(new Date())
			const days = montageDateMoment.diff(nowMoment, 'days')
			const hours = montageDateMoment.diff(nowMoment, 'hours')

			if (days === 0 && hours < 24) return `Montaż za ${hours} godzin!`

			return `Montaż za ${days} dni!`
		},
		getSecondsLeftToEdit() {
			if (!this.currentOrder) return 0
			const nowMoment = moment(new Date())
			return 30 * 60 - Number(moment(nowMoment).diff(this.currentOrder.createdDate, 'seconds'))
		},
		calculateCommission() {
			let commission = 0
			if (this.currentOrder && this.currentOrder.price) {
				if (this.currentOrder.price <= 30000) commission = 1000
				else if (this.currentOrder.price > 30000 && this.currentOrder.price <= 100000)
					commission = this.currentOrder.price * 0.05
				else commission = this.currentOrder.price * 0.03
			}
			this.currentOrder.commission = parseFloat(commission).toFixed(2)
			this.$toast.open({
				type: 'is-info',
				message: `Obliczona prowizja została uzupełniona.`
			})
		}
		// getPriceLabel(order) {
		// 	const currency = this.getCurrencyLabel(order.currency)
		// 	return `${order.price} ${currency}`
		// }
		// parseDate(date) {
		// 	return moment(date)
		// }
	},
	created() {
		// parse productsLinks array
		if (this.currentOrder.productsLinks) {
			this.productsLinks = JSON.parse(this.currentOrder.productsLinks)
		}

		this.isEditModeEnabled = this.isEditModeActive
		this.secondsLeftToEdit = this.getSecondsLeftToEdit()

		this.timeToEditInterval = setInterval(() => {
			this.secondsLeftToEdit = this.getSecondsLeftToEdit()
			if (!this.canEdit) this.isEditModeEnabled = false
		}, 1000)
	},
	destroyed() {
		this.$store.dispatch('orders/setCurrentOrder', null)
		clearInterval(this.timeToEditInterval)
	}
}
</script>

<style lang="scss" scoped>
.modal-card-title > * {
	vertical-align: middle;
}
h2 {
	display: inline-block;
	margin-right: 10px;
	vertical-align: middle;
}
.history {
	padding: 25px;
	.list {
		position: relative;
		line-height: 35px;
	}
	li {
		position: relative;
		display: flex;
		align-items: center;
		&:hover {
			.editor {
				display: block;
			}
		}
	}
}
.field-body .field .field {
	margin-bottom: 10px;
}
.action-buttons {
	justify-content: space-between !important;
}
.show-full-history {
	margin-top: 20px;
	display: block;
}
.datetime {
	small {
		color: rgb(194, 194, 194);
	}
}
.editor {
	display: none;
	position: absolute;
	top: -13px;
	left: 19px;
	font-size: 12px;
	font-style: italic;
}
.action-icon {
	width: 8px;
	height: 8px;
	border-radius: 8px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
	&[data-action='create'] {
		background-color: green;
	}
	&[data-action='update'] {
		background-color: blue;
	}
	&[data-action='status change'] {
		background-color: rgb(179, 18, 170);
	}
}
.is-pdf-link,
.is-doc-link {
	margin-right: 10px;
}
.file-name {
	font-size: 1rem;
}
.picture-wrapper {
	display: flex;
	flex-direction: column;
}
.picture {
	margin-bottom: 10px;
	border: 1px solid #ccc;
	padding: 5px;
	border-radius: 5px;
	&__empty {
		color: #ccc;
	}
	&__buttons {
		justify-content: space-between;
	}
}
.flag {
	width: 20px;
	box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
	margin-right: 5px;
}
.to-route-button {
	margin-left: 10px;
}
.warning-icon {
	vertical-align: middle;
	padding-right: 5px;
	animation: blink-animation 1s steps(5, start) infinite;
}
.calculate-commission-wrapper {
	display: flex;
	justify-content: flex-end;
	padding-right: 25px;
}
@keyframes blink-animation {
	to {
		color: red;
	}
}

.fade-enter {
	opacity: 0;
}
.fade-enter-active {
	animation: fadein 0.3s;
}
.fade-leave {
	opacity: 1;
}
.fade-leave-active {
	animation: fadein 0.2s reverse;
}
@keyframes fadein {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
</style>
